<template>
    <div class="mb-50px">
        <div class="giftcard-slide-wrap">
            <div class="giftcard-slide">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <!-- is-active 활성화 효과 -->
                        <div v-for="brand in brands" :key="brand?._id" :class="`swiper-slide py-1 d-flex justify-center ${ $route?.query?._brand === brand?._id ? 'is-active' : '' }`" @click="$emit('setBrand', brand)">
                            <div class="rounded-item"><img :src="`https://daehanbooksgiftcard.com/${brand?.subThumb}`" alt="" /></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="">
                <div class=".giftcard-slide-wrap swiper-prev"><img src="/images/giftcard/arrow-lt.png" alt="<" /></div>
                <div class=".giftcard-slide-wrap swiper-next"><img src="/images/giftcard/arrow-rt.png" alt=">" /></div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api'
export default {
    data() {
        return {
            brands: [],

            filter: {
                _category: this.$route.query._category || null
            }
        }
    },
    async mounted() {
        await this.init()
    },
    methods: {
        async init() {
            await this.search()
            this.$nextTick(() => {
                const swiper = new window.Swiper(".giftcard-slide .swiper-container", {
                    slidesPerView: 4,
                    spaceBetween: 0,
                    speed: 500,
                    loop: false,
                    navigation: {
                        nextEl: ".giftcard-slide-wrap .swiper-next",
                        prevEl: ".giftcard-slide-wrap .swiper-prev",
                    },
                    breakpoints: {
                        576: { slidesPerView: 4 },
                        768: { slidesPerView: 6 },
                        1024: { slidesPerView: 6 },
                        1200: { slidesPerView: 8 },
                    },
                });
            });
        },
        async search(){
            let { brands } = await api.v1.gshop.brands.gets({params: { ...this.filter }})
            this.brands = brands;
        },
    },
    computed: {
        _category() {
            return this.$route.query._category;
        },
        _brand() {
            return this.$route.query._brand;
        }
    },
    watch: {
        async "$route.query._category"() {
            this.filter._category = this.$route.query._category;
            await this.init();
        }
    }
};
</script>

<style lang="scss" scoped>
.giftcard-slide-wrap {
    position: relative;
    .giftcard-slide {
        padding: 0 0;
    }
    .swiper-prev {
        left: 0;
    }
    .swiper-next {
        right: 0;
    }
    .swiper-prev,
    .swiper-next {
        display: none;
    }
    .swiper-slide {
        .rounded-item {
            position: relative;
            cursor: pointer;
            min-width: 60px;
            width: 60px;
            height: 60px;
            border-radius: 50%;
            overflow: hidden;
            // background-color: azure;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
            box-shadow: rgba(149, 157, 165, 0.2) 0px 2px 4px;
            &::after{
                content: "";
                display: block;
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                z-index: 2;
                background-color: #000;
                opacity: 0;
                transition: 0.1s;
            }
        }
        &.is-active {
            .rounded-item::after {
                opacity: 0.15;
            }
        }
    }
}

@media (min-width: 768px) {
    .giftcard-slide-wrap {
        .giftcard-slide {
            padding: 0 30px;
        }
        .swiper-slide {
            .rounded-item {
                min-width: 80px;
                width: 80px;
                height: 80px;
            }
        }
        .swiper-prev,
        .swiper-next {
            display: flex;
            width: 20px;
            height: 34px;
        }
    }
}

@media (min-width: 1200px) {
    .giftcard-slide-wrap {
        .giftcard-slide {
            padding: 0 60px;
        }
    }
}
</style>








